import { parseUserRole, UserRole } from "$lib/auth/roles";
import type { AuthUser } from "$lib/auth/types";

/** Unverified JWT payload decode (browser). Signature is checked by the API. */
export function decodeJwtPayload(token: string): Record<string, unknown> | null {
  try {
    const segment = token.split(".")[1];
    if (!segment) return null;
    const padded = segment.replace(/-/g, "+").replace(/_/g, "/");
    const pad = padded.length % 4 === 0 ? "" : "=".repeat(4 - (padded.length % 4));
    const binary = atob(padded + pad);
    const bytes = Uint8Array.from(binary, (c) => c.charCodeAt(0));
    return JSON.parse(new TextDecoder().decode(bytes)) as Record<string, unknown>;
  } catch {
    return null;
  }
}

export function userFromAccessToken(accessToken: string): AuthUser | null {
  const payload = decodeJwtPayload(accessToken);
  if (!payload || payload.typ !== "access") return null;

  const id = typeof payload.sub === "string" ? payload.sub : null;
  if (!id) return null;

  const role = parseUserRole(payload.role) ?? UserRole.BROKER;
  const email =
    (typeof payload.login_email === "string" && payload.login_email) ||
    (typeof payload.email === "string" && payload.email) ||
    "";

  return {
    id,
    email,
    firstName: typeof payload.first_name === "string" ? payload.first_name : "",
    lastName: typeof payload.last_name === "string" ? payload.last_name : "",
    role,
  };
}

export function accessTokenExpiresAtMs(accessToken: string): number | null {
  const payload = decodeJwtPayload(accessToken);
  if (!payload || typeof payload.exp !== "number") return null;
  return payload.exp * 1000;
}
